import { FormattedMessage } from 'react-intl';
import { useLocale } from '../../configuration/lang/langSlice';
import { useRef } from 'react';
import useOnScreen from '@rio-cloud/rio-uikit/hooks/useOnScreen';
import { useAdvertisementSeen } from '../../hooks/useAdvertisementSeen';
import { YouTubeEmbed } from './YouTubeEmbed';
import { Link } from 'react-router-dom';
import { getShortLocale } from '../../hooks/useTranslations';
import { gaPush } from '../../configuration/setup/googleAnalytics';
import NotBookedState from '@rio-cloud/rio-uikit/components/states/NotBookedState';
import type { VideoCampaign } from '../../hooks/useGetUpsellingCampaign';

export const UpsellingVideoView = ({ campaign }: { campaign: VideoCampaign }) => {
    const ref = useRef(null);
    const inView = useOnScreen(ref);
    const locale = useLocale() ?? 'en-GB';

    useAdvertisementSeen(inView);

    return (
        <div ref={ref}>
            <NotBookedState
                headline={<FormattedMessage id='intl-msg:chat.notBooked.chatA.headline' />}
                message={<FormattedMessage id='intl-msg:chat.notBooked.chatA.message' />}
                outerClassName='border-none padding-0'
                condensed
            >
                <div className='padding-bottom-15 margin-top--20 width-100pct'>
                    <YouTubeEmbed
                        title={'Video'}
                        src={campaign.url}
                        gaEventCategory={campaign.trackingCategory}
                        startSeconds={campaign.startSeconds}
                    />
                </div>
                <div className='padding-bottom-15 padding-top-15 margin-top--20 text-wrap-balance '>
                    <FormattedMessage
                        id='intl-msg:chat.notBooked.learnMore'
                        values={{
                            b: chunk => <span className='text-bold'>{chunk}</span>,
                            l: chunk => (
                                <Link
                                    to={`https://rio.cloud/${getShortLocale(locale)}/marketplace/produkt/order-communication`}
                                    target='_blank'
                                    className='text-bold text-decoration-underline hover-text-decoration-none underline-offset-3'
                                    onClick={() => {
                                        gaPush({
                                            category: campaign.trackingCategory,
                                            action: 'Learn more',
                                            label: 'Clicked learn more link in upselling advertisement',
                                        });
                                    }}
                                >
                                    {chunk}
                                </Link>
                            ),
                        }}
                    />
                </div>
                <iframe
                    className='buyButton'
                    src={`https://buybutton.marketplace.rio.cloud/?productId=RIO-SKU00000094&level=14&locale=${locale}&internalCampaign=${campaign.trackingCategory.replace(',', '_').replace(' ', '')}`}
                    title='Upselling'
                />
            </NotBookedState>
        </div>
    );
};
